<template>
  <v-main class="bg-grey-lighten-4">
    <!-- Заголовок группы -->
    <v-card class="mb-4 pa-2 px-4" elevation="1">
      <v-row align="center" no-gutters>
        <!-- Центр: Название и Переключатель (на мобилке идет первым) -->
        <v-col cols="12" md="8" :class="mobile ? 'order-0 mb-2' : 'order-1'" class="text-center">
          <h2 class="text-h6 font-weight-bold">
            Расписание группы {{ groupName }}
          </h2>
          <div class="text-subtitle-2 text-medium-emphasis d-flex align-center justify-center position-relative">
            <v-btn icon="mdi-chevron-left" size="small" variant="text" @click="decDate"></v-btn>
            <span class="mx-2">
              {{ mobile ? currentTimeDisplay : 'Расписание на неделю' }}
              <v-btn v-if="!mobile" icon="mdi-calendar" size="x-small" variant="text"
                @click="displayBottomSheetCalendar = true"></v-btn>
            </span>
            <v-btn icon="mdi-chevron-right" size="small" variant="text" @click="incDate"></v-btn>
            <!--datepicker-->
            <!-- Кнопка для МОБИЛКИ (абсолютное позиционирование справа) -->
            <div v-if="mobile" class="position-absolute" style="right: 0">
              <v-btn icon="mdi-calendar" size="small" variant="text" @click="displayBottomSheetCalendar = true"></v-btn>
            </div>
            <!-- КАЛЕНДАРЬ (управляется через v-model) -->
            <v-bottom-sheet v-model="displayBottomSheetCalendar">
              <v-card class=" d-flex align-center justify-center">
                <v-locale-provider locale="ru">
                  <v-date-picker v-model="datePickerData" :min="minDate" :max="maxDate" hide-header
                    @update:model-value="displayBottomSheetCalendar = false"></v-date-picker>
                </v-locale-provider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn variant="text" @click="displayBottomSheetCalendar = false">Отмена</v-btn>
                </v-card-actions>
              </v-card>
            </v-bottom-sheet>
          </div>
        </v-col>

        <!-- Левая часть: Кнопка возврата -->
        <v-col cols="6" md="2" :class="mobile ? 'order-1' : 'order-0'" class="d-flex justify-start">
          <v-btn variant="text" color="primary" @click="toSearchPage()" class="text-none px-1">
            <v-icon :class="{ 'mr-1': !mobile }">mdi-arrow-left</v-icon>
            <span>К выбору групп</span>
          </v-btn>
        </v-col>

        <!-- Правая часть: Переключатель отмен -->
        <v-col cols="6" md="2" class="order-2 d-flex justify-end">
          <v-switch v-model="showCancelled" color="error" hide-details density="compact" label="Отмены"
            class="mt-0 pt-0 custom-switch"></v-switch>
        </v-col>

      </v-row>
    </v-card>

    <v-alert :icon="false" v-if="errorMessage" closable :text="errorMessage" type="error"></v-alert>
    <v-container class="pa-2" fluid v-if="mobile && timetable && timetableList.length">
      <!-- Список уроков -->
      <div v-for="(lessons, index) in timetableList[0]['lessons']" :key="index" class="mb-3">
        <!-- Добавляем динамический класс 'current-lesson' и меняем elevation -->
        <v-card variant="flat" :class="[
          'rounded-lg border',
          { 'current-lesson': isCurrent(lessons[0]) && isToday(lessons[0].date) },
        ]" :elevation="isCurrent(lessons[0]) && isToday(lessons[0].date) ? 4 : 0">
          <v-row no-gutters>
            <!-- Левая колонка: Время -->
            <v-col cols="3" :class="[
              { 'bg-green-accent-1': isCurrent(lessons[0]) && isToday(lessons[0].date) && lessons[0].cancel != 1 },
            ]" class="d-flex flex-column align-center justify-center border-e">
              <span class="text-caption font-weight-bold">Пара {{ lessons[0].lesson }}</span>
              <div class="text-body-2 font-weight-black">{{ lessons[0].lesson_start ?? '?' }}</div>
              <div class="text-caption">{{ lessons[0].lesson_end ?? '?' }}</div>

              <!-- Метка "Сейчас" -->
              <v-chip v-if="isCurrent(lessons[0]) && isToday(lessons[0].date)" size="x-small" color="white"
                variant="flat" class="mt-1 text-primary">
                СЕЙЧАС
              </v-chip>
            </v-col>

            <!-- Правая колонка: Дисциплины -->
            <v-col cols="9" class="flex-grow-1 d-flex flex-column">
              <template v-for="(sub, sIdx) in lessons" :key="sub.id">
                <div v-if="sub.cancel != 1 || showCancelled" :class="[
                  { 'border-b': sIdx !== lessons.length - 1 },
                  { 'bg-red-lighten-5 opacity-60': sub.cancel == 1 },
                  { 'bg-green-accent-1': isToday(sub.date) && isCurrent(lessons[0]) && sub.cancel != 1 }
                ]" class="pa-2 px-3 d-flex align-center flex-grow-1 overflow-hidden">
                  <!-- Одной строкой: Дисциплина + Препод + Аудитория -->
                  <div class="d-flex align-center w-100 ga-2 py-1">

                    <!-- Блок текста: Дисциплина и Преподаватель -->
                    <div class="d-flex flex-grow-1 overflow-hidden"
                      :class="mobile ? 'flex-column' : 'align-center ga-2'">

                      <div class="d-flex align-center overflow-hidden">
                        <!-- Метка отмены (иконка или текст) -->
                        <v-chip v-if="sub.cancel == 1" size="x-small" color="error" variant="flat"
                          class="mr-1 flex-shrink-0">Х</v-chip>

                        <!-- Дисциплина -->
                        <div
                          :class="['text-body-2 font-weight-bold text-truncate', { 'text-decoration-line-through': sub.cancel == 1 }]">
                          {{ sub.discipline_short }}
                        </div>

                        <!-- Разделитель (только для десктопа) -->
                        <span v-if="!mobile" class="text-grey-lighten-2 mx-1">|</span>
                      </div>

                      <!-- Преподаватель (на мобилке под дисциплиной, на десктопе в ряд) -->
                      <div class="text-caption text-grey-darken-1 text-truncate">
                        {{ sub.lastname }}
                      </div>
                    </div>

                    <!-- Аудитория (всегда справа) -->
                    <v-chip v-if="sub.classroom" size="x-small" variant="flat" color="grey-lighten-4"
                      class="font-weight-bold flex-shrink-0 ml-auto">
                      {{ sub.classroom }}
                    </v-chip>
                  </div>
                </div>
              </template>
            </v-col>
          </v-row>
        </v-card>
      </div>

    </v-container>
    <!--десктоп-->
    <v-row v-if="!mobile && timetable && timetableList.length">
      <v-col v-for="day in filteredTimetable" :key="day.date" cols="12" md="4">
        <v-card class="rounded-xl fill-height d-flex flex-column" elevation="2" border>
          <!-- Заголовок дня внутри карточки -->
          <v-card-item :class="isToday(day.date) ? 'bg-primary text-white' : 'bg-grey-lighten-4'">
            <v-card-title class="text-h6 font-weight-bold">
              {{ formatDateFull(day.date) }}
            </v-card-title>
            <template #append>
              <v-icon v-if="isToday(day.date)">mdi-calendar-check</v-icon>
            </template>
          </v-card-item>

          <v-divider></v-divider>

          <v-card-text class="pa-0 flex-grow-1">
            <div v-if="day.lessons.length">
              <div v-for="(lessonGroup, idx) in day.lessons" :key="idx">
                <!-- Контейнер одной пары -->
                <div :class="['d-flex align-stretch', { 'current-lesson-border': isCurrent(lessonGroup[0]) }]"
                  style="min-height: 50px;"> <!-- Уменьшили высоту -->

                  <!-- Левый блок: Номер и Время в одну строку -->
                  <div class="pa-2 text-center d-flex align-center border-e bg-grey-lighten-5"
                    style="min-width: 80px; flex-shrink: 0;">
                    <!--номер урока
                    <div class="text-subtitle-1 font-weight-bold text-primary mr-2">{{ lessonGroup[0].lesson }}</div>
                    -->
                    <div class="d-flex flex-column justify-center text-no-wrap">
                      <div class="text-caption font-weight-black line-height-1">{{ lessonGroup[0].lesson_start ?? '?' }}</div>
                      <div class="text-caption text-medium-emphasis line-height-1">{{ lessonGroup[0].lesson_end ?? '?' }}</div>
                    </div>
                  </div>

                  <!-- Информация о дисциплинах -->
                  <div class="flex-grow-1 d-flex flex-column">
                    <template v-for="(sub, sIdx) in lessonGroup" :key="sub.id">
                      <div v-if="sub.cancel != 1 || showCancelled" :class="[
                        { 'border-b': sIdx !== lessonGroup.length - 1 },
                        { 'bg-red-lighten-5 opacity-60': sub.cancel == 1 },
                        { 'bg-green-accent-1': isToday(day.date) && isCurrent(lessonGroup[0]) && sub.cancel != 1 }
                      ]" class="pa-2 px-3 d-flex align-center flex-grow-1 overflow-hidden">
                        <!-- Одной строкой: Дисциплина + Препод + Аудитория -->


                        <div class="schedule-grid-container w-100 px-1">

                          <!-- 1. Отмена (фиксированная ширина) -->
                          <div v-if="sub.cancel == 1" class="grid-cancel">
                            <v-chip size="x-small" color="error" variant="flat">Х</v-chip>
                          </div>
                          <div v-else></div> <!-- Пустая ячейка для сохранения сетки, если нет отмены -->

                          <!-- 2. Контент (Дисциплина | Преподаватель) -->
                          <div class="grid-content d-flex align-center ga-1 overflow-hidden">
                            <div class="text-body-2 font-weight-bold text-truncate flex-shrink-1"
                              :class="{ 'text-decoration-line-through': sub.cancel == 1 }" style="max-width: 55%">
                              {{ sub.discipline_short }}
                            </div>

                            <div class="text-caption text-grey-darken-1 text-truncate flex-grow-1">
                              {{ sub.lastname }}
                            </div>
                          </div>

                          <!-- 3. Аудитория (принудительный размер по контенту) -->
                          <div v-if="sub.classroom" class="grid-room d-flex justify-end ml-2">
                            <v-chip size="x-small" variant="tonal" color="grey-darken-1"
                              class="font-weight-bold flex-shrink-0">
                              {{ sub.classroom }}
                            </v-chip>
                          </div>
                          <div v-else></div>
                        </div>




                      </div>
                    </template>
                  </div>
                </div>
                <v-divider v-if="idx !== day.lessons.length - 1"></v-divider>
              </div>
            </div>

            <!-- Пустой день -->
            <div v-else class="pa-12 text-center d-flex flex-column align-center justify-center h-100">
              <v-icon size="48" color="grey-lighten-2">mdi-coffee-outline</v-icon>
              <span class="text-grey text-button mt-2">Пар нет</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-skeleton-loader v-if="!timetable || !timetableList.length" type="article"></v-skeleton-loader>
  </v-main>
</template>


<script>
import { useDisplay } from 'vuetify'
import { procollegeStore } from 'moodleDir/procollege/lib/vue/store.js'
export default {
  name: 'GroupTimetablePage',
  setup() {
    const { mobile } = useDisplay()
    return { mobile }
  },
  data() {
    return {
      displayBottomSheetCalendar: false,
      datePickerData: null,
      maxDate: null,
      minDate: null,


      currentDateYMD: null,
      errorMessage: null,
      showCancelled: false,
      now: new Date(), // Состояние для текущего времени
      timer: null,
      timetable: null
    }
  },

  computed: {
    // Фильтруем уроки внутри каждого дня на основе чекбокса
    filteredTimetable() {
      // Делаем глубокую копию, чтобы не мутировать исходные данные
      return this.timetableList.map(day => {
        const newDay = { ...day };

        // Фильтруем группы уроков
        newDay.lessons = day.lessons.map(group => {
          // Внутри группы (подгруппы одной пары) фильтруем отмененные
          return group.filter(lesson => {
            return true;
            if (this.showCancelled) return true; // Показываем всё
            return lesson.cancel != 1; // Только активные
          });
        }).filter(group => group.length > 0); // Убираем пустые группы пар после фильтрации

        return newDay;
      });
    },

    currentTimeDisplay() {
      //const firstDay = this.timetableList[0];
      //const dateStr = firstDay?.lessons[0]?.[0]?.date || '';
      // Заменяем точки на дефисы, чтобы конструктор Date гарантированно понял формат ГГГГ-ММ-ДД
      const date = new Date(this.currentDateYMD.replace(/\./g, '-'));

      const formatter = new Intl.DateTimeFormat('ru', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      return formatter.format(date)
    },
    // Приводим данные к единому виду: всегда массив дней
    timetableList() {
      // Просто приводим к массиву, фильтрацию сделаем в шаблоне через v-if
      return Array.isArray(this.timetable) ? this.timetable : [this.timetable];
    },
    groupName() {
      // Берем имя из первого доступного урока
      const firstDay = this.timetableList[0];
      return firstDay?.gname || '';
    }
  },
  watch: {
    mobile(newVal) {
      this.loadTimetable()
    },
    showCancelled(newVal, oldVal) {
      const store = new procollegeStore();
      store.set('timetable:showCancelled', newVal, false);
    },
    datePickerData(newVal, oldVal) {
      const date = new Date(newVal)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      this.currentDateYMD = `${year}.${month}.${day}`;
      this.loadTimetable();
    }
  },
  async created() {

    this.axios.post(this.$model.wwwroot +
      "/procollege/core_procollege/helpers/rest/getCurrentSemesterSettings"
    ).then((response) => {
      this.minDate = response.data.semester_begin;
      this.maxDate = response.data.semester_end;
    }).catch((error) => {
      console.log(error)
      this.errorMessage = error.response.data
    }).finally(() => {
    });


    const store = new procollegeStore();
    store.set('timetable:lastGroup', this.$route.params.id, false);

    const cancelled = await store.get('timetable:showCancelled');
    if (cancelled) {
      this.showCancelled = cancelled;
    }

    const now = new Date();
    this.currentDateYMD = now.toLocaleDateString('ru-RU').split('.').reverse().join('.');
    this.loadTimetable();
  },
  mounted() {
    // Обновляем время каждую минуту для точности подсветки
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 60000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    loadTimetable() {
      this.timetable = null;
      this.axios.post(this.$model.wwwroot +
        "/procollege/core_procollege/helpers/rest/getGroupTimetable",
        new URLSearchParams({
          group_id: this.$route.params.id,
          date: this.currentDateYMD,
          mode: this.mobile ? 'day' : 'week'
        }),
      ).then((response) => {
        this.timetable = response.data;
      }).catch((error) => {
        console.log(error)
        this.errorMessage = error.response.data
      }).finally(() => {
      });
    },

    // Универсальный метод изменения даты
    changeDate(direction = 1) {
      this.errorMessage = null;
      const [y, m, d] = this.currentDateYMD.split('.').map(Number);
      const date = new Date(y, m - 1, d);

      const step = this.mobile ? 1 : 7;

      // Изменяем дату первый раз
      date.setDate(date.getDate() + (step * direction));

      // Если это мобильная версия и мы попали на воскресенье (0)
      if (this.mobile && date.getDay() === 0) {
        // Делаем еще один шаг в том же направлении (на Пн или на Сб)
        date.setDate(date.getDate() + direction);
      }

      // Сохраняем в формате Y.m.d
      // Используем ручной формат, чтобы избежать сюрпризов от локали браузера
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      this.currentDateYMD = `${year}.${month}.${day}`;

      this.loadTimetable();
    },

    // Обертки для кнопок
    incDate() {
      this.changeDate(1);
    },
    decDate() {
      this.changeDate(-1);
    },
    isToday(dateStr) {
      // Сравнение YYYY.MM.DD
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, '.');
      return dateStr === today;
    },
    formatDateFull(dateStr) {
      // Предполагаем формат YYYY.MM.DD или YYYY-MM-DD
      const date = new Date(dateStr.replace(/\./g, '-'));
      return date.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        weekday: 'long'
      }).replace(/^\w/, (c) => c.toUpperCase()); // Первая буква заглавная
    },

    isCurrent(lesson) {
      //время вообще не задано
      if(!lesson.lesson_start || !lesson.lesson_end){
        return false
      }
      // Это сработает для "10-20", "10:20", "10.20" и т.д.
      const [startH, startM] = lesson.lesson_start.split(/\D+/).map(Number);
      const [endH, endM] = lesson.lesson_end.split(/\D+/).map(Number);

      const startTime = new Date(this.now).setHours(startH, startM, 0);
      const endTime = new Date(this.now).setHours(endH, endM, 0);
      const currentTime = this.now.getTime();


      return currentTime >= startTime && currentTime <= endTime;
    },
    async toSearchPage() {
      const store = new procollegeStore();
      await store.remove('timetable:lastGroup');
      this.$router.push('/')
    },
  }
}
</script>
<style>
/* Дополнительный визуальный эффект для текущего занятия */
.current-lesson {
  border: 2px solid rgb(var(--v-theme-primary)) !important;
  transform: scale(1.02);
  transition: all 0.3s ease;
  z-index: 10;
}

html {
  font-size: 18px;
}

.schedule-grid-container {
  display: grid;
  /* 
     - auto: для иконки отмены
     - 1fr: текст забирает всё свободное место, но может сжиматься
     - max-content: аудитория ВСЕГДА занимает столько, сколько нужно её тексту
  */
  grid-template-columns: auto 1fr max-content;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.grid-content {
  min-width: 0;
  /* Разрешаем внутренним текстам сокращаться */
}

.grid-room {
  /* Запрещаем ячейке схлопываться в 0 */
  min-width: max-content;
  flex-shrink: 0;
}
</style>